module.exports = __webpack_public_path__ + "img/title_text@x.779fca2d.png";